import { useEffect, useState } from "react";
import { apiDelete, apiGet, apiPost, getToken } from "../lib/api";

type Props = { postId: string };

export default function LikeButton({ postId }: Props) {
  const [count, setCount] = useState<number>(0);
  const [liked, setLiked] = useState<boolean | null>(null); // null = login değil
  const [loading, setLoading] = useState(false);
  const [animating, setAnimating] = useState(false);

  // Login ise state endpointini, değilse sadece sayacı çek.
  async function refresh() {
    const hasToken = getToken();
    
    if (hasToken) {
      try {
        const res = await apiGet<{ ok: true; count: number; liked: boolean }>(`/api/likes/state/${postId}`);
        setCount(res.count);
        setLiked(res.liked);
        return;
      } catch (err: any) {
        // 401 ise token geçersiz, public count'a düş
        if (err?.status === 401 || err?.message?.includes('401')) {
          // Token geçersiz, public count'a düş
        } else {
          // Başka bir hata, sessiz geç
          return;
        }
      }
    }
    
    // Giriş yapmamış veya token geçersiz - public count
    try {
      const res = await apiGet<{ ok: true; count: number }>(`/api/likes/${postId}`);
      setCount(res.count);
      setLiked(null);
    } catch {
      // sessiz geç (UI'de mevcut değerler kalsın)
    }
  }

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  async function toggle() {
    if (liked === null || loading) return; // login değilse pasif
    setLoading(true);
    
    // Trigger animation
    setAnimating(true);
    setTimeout(() => setAnimating(false), 600);
    
    try {
      if (liked) {
        const res = await apiDelete<{ ok: true; count: number; liked: false }>(`/api/likes/${postId}`);
        setCount(res.count);
        setLiked(false);
      } else {
        // ⬇️ apiPost: 401 → refresh, cookies → include
        const res = await apiPost<{ ok: true; count: number; liked: true }>(`/api/likes/${postId}`);
        setCount(res.count);
        setLiked(true);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={toggle}
      disabled={loading || liked === null}
      className={animating ? "animate-heart-pulse" : ""}
      style={{
        marginLeft: 8,
        cursor: loading || liked === null ? "not-allowed" : "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        transition: "transform 0.2s",
      }}
      onMouseOver={(e) => {
        if (!loading && liked !== null) {
          e.currentTarget.style.transform = "scale(1.1)";
        }
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
      aria-label={liked ? "Beğenmekten vazgeç" : "Beğen"}
      title={liked === null ? "Giriş yapmalısın" : liked ? "Beğenmekten vazgeç" : "Beğen"}
    >
      <span style={{ fontSize: "18px" }}>{liked ? "❤️" : "🤍"}</span>
      <span style={{ fontWeight: "600" }}>{count}</span>
    </button>
  );
}
